import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "checkmark-outline",
  "use": "checkmark-outline-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"checkmark-outline\"><path d=\"M483 70s7 10 0 23c0 0-233 153-281 345 0 0-10 7-20 7-6 0-12 0-19-7 0 0-70-115-137-153 0 0-7-13 0-19l144 70c3 0 92-141 313-266m0-25c-3 0-9 0-13 3-179 102-275 211-307 256L38 240c-3 0-6-3-9-3-10 0-16 3-23 13-9 19-3 38 0 44 4 4 7 10 10 13 48 29 109 115 128 144 3 3 3 7 6 7 10 6 23 9 32 9 20 0 32-9 36-9 3-4 6-10 9-16 45-183 269-330 272-330 3-3 7-3 7-10 12-19 6-38-4-51-6-3-12-6-19-6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/checkmark-outline.svg
// module id = 189
// module chunks = 0